import { render, staticRenderFns } from "./RoleListTable.vue?vue&type=template&id=5e5f6e7a&scoped=true"
import script from "./RoleListTable.vue?vue&type=script&lang=js"
export * from "./RoleListTable.vue?vue&type=script&lang=js"
import style0 from "./RoleListTable.vue?vue&type=style&index=0&id=5e5f6e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5f6e7a",
  null
  
)

export default component.exports